import TicketEntityContent from '@/components/entity-detail/components/Entity/TicketEntity';
import type { TDetailServiceParams } from '@/components/entity-detail/types/EntityType.types';
import { TICKET_PARAMS } from '@/constants/query-params/ticket.constant';
import { ticketService } from '@/services/rest';
import type { TicketResponse } from '@/types/apps/ticket.type';
import type { ApiResponse } from '@/types/common/api.type';
import { t } from '@/utils/lang';
import { Entity } from '../entity';

export class TicketEntity extends Entity {
    public getTitleTemplate(response?: string): string {
        if (!response) {
            return t('Ticket');
        }

        return `${t('Ticket')}: ${this.getTitle(response)}`;
    }

    public getEntityComponent(): any {
        return TicketEntityContent;
    }

    public getIncludeProperties() {
        return TICKET_PARAMS;
    }

    public getDetailService(
        params: TDetailServiceParams
    ): Promise<ApiResponse<TicketResponse>> {
        return ticketService().detail(params.id, {
            ...this.getIncludeProperties(),
            ...params,
        });
    }

    public getFieldName(): string {
        return 'name';
    }

    public getDetailUrl(id: string): string {
        return this.routeManager.getRouteMap()[this.getRouteDetail()].path(id);
    }

    public showDetailButton(): boolean {
        return true;
    }

    public getRouteDetail(): string {
        return this.routeManager.TICKET_DETAIL;
    }
}
